"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FailureCircle = function FailureCircle() {
	return _react2.default.createElement(
		"g",
		{ id: "failure-circle" },
		_react2.default.createElement("path", { d: "M255.968 0C115.185 0 0 114.823 0 255.16 0 395.5 115.185 510.324 255.968 510.324S511.935 395.5 511.935 255.16C511.935 114.824 396.75 0 255.968 0zm125.424 344.468l-35.836 35.722-89.588-89.306-89.59 89.306-35.834-35.722 89.588-89.307-89.588-89.303 35.835-35.723 89.586 89.307 89.588-89.307 35.836 35.723-89.59 89.306 89.59 89.31z" })
	);
};

exports.default = FailureCircle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FailureCircle.js
// module id = 2948
// module chunks = 4